import React from 'react'

const BillList = () => {
  return (
    <div>BillList</div>
  )
}

export default BillList